var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTklaytn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8D91AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6896 19.7998L16.445 4.65256C17.5641 4.56117 20.4738 4.95413 23.1596 7.25706C20.0353 10.3825 13.5445 16.9211 10.6896 19.7998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4303 6.57166L4.66011 15.3447C4.54592 16.9897 4.87937 20.8416 7.12672 23.0897C8.49705 19.3063 11.9001 10.5013 13.4303 6.57166Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2967 24.6661C17.3768 29.5461 11.1007 26.6995 8.7026 24.6661L15.9654 17.4695C17.6098 19.1144 21.3782 22.8567 23.2967 24.6661Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.667 23.1582C26.6997 20.7594 29.5454 14.4811 24.667 8.55931C22.8582 10.4784 19.1172 14.2481 17.4727 15.893L24.667 23.1582Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTklaytn);
export default __webpack_public_path__ + "static/media/tklaytn.64a1aea9ba2fbd3acee789edf54e62d1.svg";
export { ForwardRef as ReactComponent };